import { render } from "./JsonTagsField.vue?vue&type=template&id=20390682"
import script from "./JsonTagsField.vue?vue&type=script&lang=js"
export * from "./JsonTagsField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"JsonTagsField.vue"]])

export default __exports__